import { getWarningIcon } from './SeverityIcon';
import { getCircleIcon } from './StateIcon';

export const stateDropDownOption = [
  {
    id: 'New',
    name: 'New',
    icon: () => getCircleIcon('New'),
  },
  {
    id: 'In Progress',
    name: 'In Progress',
    icon: () => getCircleIcon('In Progress'),
  },
  {
    id: 'Resolved',
    name: 'Resolved',
    icon: () => getCircleIcon('Resolved'),
  },
  {
    id: 'Done',
    name: 'Done',
    icon: () => getCircleIcon('Done'),
  },
];

export const severityDropDownOption = [
  {
    id: '1 - Critical',
    name: 'Severity 1 - Critical',
    icon: () => getWarningIcon('1 - Critical'),
  },
  {
    id: '2 - High',
    name: 'Severity 2 - High',
    icon: () => getWarningIcon('2 - High'),
  },
  {
    id: '3 - Medium',
    name: 'Severity 3 - Medium',
    icon: () => getWarningIcon('3 - Medium'),
  },
  {
    id: '4 - Low',
    name: 'Severity 4 - Low',
    icon: () => getWarningIcon('4 - Low'),
  },
];
